import React, { useRef, useEffect, useState } from "react";
import { colorPalette } from "../../constants/data";
import SwiperCore, { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import Circle from "../shared/Circle.jsx";
import Modal from "../shared/Modal.jsx";
import gsap from "gsap";
import Image from "./sliders/Image.jsx";
import Iframe from "./sliders/Iframe.jsx";
import { useScreenDetector } from "../../hooks/useScreenDetector";
import { useLanguage } from "../../contexts/LanguageContext";

export default function SliderSection(props) {
  const { language } = useLanguage(); // Dil bilgisini context'ten al
  const [selectedTab, SetSelectedTab] = useState(null);
  const [selectedSection, setSelectedSection] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const slideRef = useRef();
  const { isMobile } = useScreenDetector();

  useEffect(() => {
    // Dil değişikliğine göre ilk tab'ı seç
    SetSelectedTab(
      language === "TR" ? props.data.tabs[0] : props.data.egTabs[0]
    );
  }, [language, props.data.tabs, props.data.egTabs]);

  function handleSelected(i) {
    SetSelectedTab(
      language === "TR" ? props.data.tabs[i] : props.data.egTabs[i]
    );
    gsap.fromTo(slideRef.current, { opacity: 0 }, { opacity: 1, duration: 1 });
  }

  if (!selectedTab) return null; // 'selectedTab' henüz ayarlanmadıysa bir şey render etme

  const breakPoints = {
    1280: {
      spaceBetween: 10,
    },
    320: {
      spaceBetween: 10,
      slidesPerView: 1,
    },
  };

  function handleAction(i) {
    if (selectedTab.slides[i].modal) {
      setSelectedSection(selectedTab.slides[i]);
      setShowModal(true);
    } else {
      window.open(selectedTab.slides[i].url, "_blank");
    }
  }

  function handleSlide(el) {
    el.slides.forEach((element) => {
      // const iframe = element.querySelector('iframe');
      // iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    });
  }

  SwiperCore.use([Navigation, Pagination]);

  return (
    <div className={`w-full relative ${props.className}`} id={props.name}>
      <div className="max-w-full sm:max-w-[1440px] mx-auto my-8 pb-24 flex flex-col items-center justify-center gap-12 relative">
        {props.circle && <Circle color="bg-[#FFE3E5]" />}
        <h2 className="h-20 relative text-[42px] text-center font-semibold mt-5">
          {language === "TR" ? props.data.title : props.data.titleEN}
          <img
            src="https://srv-cdn.onedio.com/store/1b0abd9841cb6afa1be5884d8c5b6590341bdf4dc5d67dc7d59714245fcea8bc.png"
            className="absolute -bottom-3 -right-5 sm:-right-12 w-40 h-11 scale-75 sm:scale-100"
          />
        </h2>
        <p
          className="text-[#697883] text-base w-full xl:w-[950px] text-center"
          dangerouslySetInnerHTML={{
            __html:
              language === "TR"
                ? props.data.description
                : props.data.descriptionEN,
          }}
        ></p>
        <div className="flex flex-col mx-auto gap-12 max-w-full sm:max-w-[1440px]">
          <div className="flex justify-start sm:justify-center items-start left-0 gap-1 sm:gap-6 h-20 absolute sm:relative sm:h-32 max-w-full sm:max-w-[1440px] overflow-x-auto sm:overflow-visible">
            {(language === "TR" ? props.data.tabs : props.data.egTabs).map(
              (tab, i) => (
                <div
                  className={`bg-gray-100 w-auto lg:w-[250px] scale-75 sm:scale-100 pl-3 pr-2 ml-5 h-20 gap-3 flex-shrink-0 flex justify-start items-center rounded-xl border border-gray-200 cursor-pointer transition-transform duration-500 hover:bg-white hover:-translate-y-3 ${
                    tab.id === selectedTab.id && "bg-white box-shadow"
                  }`}
                  key={tab.id}
                  onClick={() => handleSelected(i)}
                >
                  <div
                    className={`rounded-full w-13 h-13 flex-shrink-0`}
                    style={{ backgroundColor: `${colorPalette[i]}` }}
                  ></div>
                  <div className="font-semibold text-base">{tab.title}</div>
                </div>
              )
            )}
          </div>
          {selectedTab.slides && (
            <div
              style={{
                width: isMobile ? "100%" : selectedTab.width,
                marginInline: "auto",
              }}
              className="mt-24 sm:mt-0"
            >
              {selectedTab.slides.length === 1 ? (
                <div onClick={() => handleAction(0)} className="cursor-pointer">
                  {selectedTab.slides[0].iframe ? (
                    <Iframe slide={selectedTab.slides[0]} />
                  ) : (
                    <Image
                      slide={{
                        ...selectedTab.slides[0],
                        section: props.name,
                      }}
                    />
                  )}
                </div>
              ) : (
                <Swiper
                  spaceBetween={selectedTab.sliderPerView ? 0 : 20}
                  slidesPerView={isMobile ? 1 : selectedTab.sliderPerView}
                  navigation={props.name === "projeler"}
                  loop
                  initialSlide={0}
                  centeredSlides
                  pagination={
                    props.name === "projeler" ? { clickable: true } : false
                  }
                  breakpoints={breakPoints}
                  ref={slideRef}
                  onSlideChange={(el) => handleSlide(el)}
                >
                  {selectedTab.slides.map((slide, i) => (
                    <SwiperSlide
                      key={slide.id}
                      data-index={i}
                      onClick={() => handleAction(i)}
                    >
                      {slide.iframe ? (
                        <Iframe slide={slide} />
                      ) : (
                        <Image
                          slide={{
                            ...slide,
                            section: props.name,
                          }}
                        />
                      )}
                    </SwiperSlide>
                  ))}
                </Swiper>
              )}
            </div>
          )}
        </div>
      </div>
      <Modal
        isShow={showModal}
        data={selectedSection}
        setShowModal={setShowModal}
      />
    </div>
  );
}
